<div class="svg_editor">
  <div id="workarea">
    <div id="svgcanvas" data-tl4k-content></div>
  </div>
</div>